import SectionLabel from '../Common/SectionLabel';
import Btn from '../Common/Btn';
import './AboutCard.css'

const AboutCard = (props) => {
    
    return ( 
        <div className={props.ACardStyle} id='ACard'>
            <SectionLabel SectionLabel="About / 02"/>

            <p className='AboutTitle'>
                {props.AboutTitle}
            </p>

            <p className='AboutP'>
                {props.AboutP}
            </p>

            <div className='AboutBtns'>
                <Btn className="GreenBtn" BtnText="Book Now" BtnPath="/booking"/>
                <Btn className="ContactBtn" BtnText="Contact Us" BtnPath="/contact"/>
            </div>
        </div>
     );
}
 
export default AboutCard;